import { DatePipe } from '@angular/common';
import { Component, computed, inject, input } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { FormsModule } from '@angular/forms';
import { ELanguage } from '@app/app.interface';
import { HasPermissionDirective } from '@core/directives/has-permission.directive';
import { INews } from '@core/interfaces/news.interface';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { BaseComponent } from '@shared/components/base.component';
import { SkeletonLoaderComponent } from '@shared/components/skeleton-loader/skeleton-loader.component';
import { ISkeletonColumn } from '@shared/components/skeleton-loader/skeleton-loader.interface';
import { QuillModule } from 'ngx-quill';
import { map } from 'rxjs';

@Component({
  imports: [TranslateModule, QuillModule, FormsModule, HasPermissionDirective, DatePipe, SkeletonLoaderComponent],
  selector: 'app-news',
  styleUrl: './news.component.scss',
  templateUrl: './news.component.html',
})
export class NewsComponent extends BaseComponent {
  public readonly news = input.required<INews[] | null>();
  public readonly loading = input<boolean>(false);

  private readonly translate = inject(TranslateService);

  // Month names follow the UI language - the date pipe's default locale (LOCALE_ID) is fixed at boot.
  public readonly locale = toSignal(this.translate.onLangChange.pipe(map(({ lang }) => lang)), {
    initialValue: this.translate.currentLang,
  });

  // German writes the day as an ordinal ("01. Oktober 2026").
  public readonly dateFormat = computed(() =>
    (this.locale() as ELanguage) === ELanguage.de ? 'dd. MMMM yyyy' : 'dd MMMM yyyy',
  );

  private readonly newsItemsArray = [0, 1, 2];
  private readonly columnsArray: ISkeletonColumn[] = [
    {
      className: 'w-full',
      columnGap: '0.5rem',
      height: '500px',
      rowMargin: '0',
      rowPadding: '0',
      textWidth: 'w-1/3',
      type: 'text',
    },
  ];

  public estimatedNewsCount(): number {
    return this.news()?.length || 3;
  }

  public createNewsItemArray(): number[] {
    return this.newsItemsArray;
  }

  public getNewsColumns(): ISkeletonColumn[] {
    return this.columnsArray;
  }
}
